// src/utils/auth.js
export const tryRefreshToken = async () => {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/refresh`, {
      method: 'POST',
      credentials: 'include', // importante para que se envíe la cookie
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    const newAccessToken = data.accessToken;

    if (newAccessToken) {
      localStorage.setItem('token', newAccessToken);
      return newAccessToken;
    }

    return null;
  } catch (error) {
    console.error('Error al refrescar el token:', error);
    return null;
  }
};
